var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.287445 8.69461L7.28146 15.7126C7.68864 16.0958 8.3114 16.0958 8.69463 15.7126C9.07786 15.3293 9.07786 14.6826 8.69463 14.2994L2.39523 8L8.69463 1.7006C9.07786 1.29341 9.07786 0.670659 8.69463 0.287425C8.3114 -0.0958084 7.68864 -0.0958084 7.28146 0.287425L0.287445 7.28144C-0.0957883 7.68862 -0.0957884 8.31138 0.287445 8.69461Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleArrow);
export default __webpack_public_path__ + "static/media/angle-arrow.a05ccf0e25e4b2d37eaf2c21c779fe90.svg";
export { ForwardRef as ReactComponent };